export default __webpack_public_path__ + "75ee87e9bafc8245cf6ace0a2447f5ad.png";